import { render, staticRenderFns } from "./Angpow.vue?vue&type=template&id=7278ac6e&scoped=true&"
import script from "./Angpow.vue?vue&type=script&lang=ts&"
export * from "./Angpow.vue?vue&type=script&lang=ts&"
import style0 from "./Angpow.vue?vue&type=style&index=0&id=7278ac6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7278ac6e",
  null
  
)

export default component.exports